export function swiperInit() {
	function getSlidesPerGroup(slidesSizesGrid, visibleSlidesIndexes) {
		const totalSlide = slidesSizesGrid.length;
		const visibleSlide = visibleSlidesIndexes?.length ?? 1;

		let slidesPerGroup = visibleSlide;

		if (totalSlide <= visibleSlide) {
			slidesPerGroup = null;
		}
		return slidesPerGroup;
	}
	function triggerLozadNextSlideImage(swiper) {
		// Load the next few slides to account for spv > 1 (e.g., --spv: 1.2, 2, 3)
		const lookAheadCount = 4;
		const loader = window.lozadObserver || window.lazyLoader;

		if (!loader || typeof loader.triggerLoad !== "function") {
			return; // Gracefully exit if lozad is not initialized yet
		}

		for (let i = 1; i <= lookAheadCount; i++) {
			const nextSlide = swiper.slides[swiper.activeIndex + i];
			if (nextSlide) {
				const nextElements = nextSlide.querySelectorAll("img, .lozad");
				nextElements.forEach((el) => {
					loader.triggerLoad(el);
				});
			}
		}
	}
	function autoSetSlidesPerGroup(swiper) {
		if (!swiper.pagination.el) return;
		const { visibleSlidesIndexes, slidesSizesGrid } = swiper;
		const slidesPerGroup = getSlidesPerGroup(
			slidesSizesGrid,
			visibleSlidesIndexes
		);
		if (
			slidesPerGroup != null &&
			slidesPerGroup > 0 &&
			slidesPerGroup !== swiper.params.slidesPerGroup
		) {
			swiper.params.slidesPerGroup = slidesPerGroup;
			swiper.update();
		}
	}
	function updateGioithieuResourcesProgress(swiper) {
		const paginationEl = swiper.pagination?.el;
		const el = paginationEl?.querySelector
			? paginationEl
			: Array.isArray(paginationEl) || paginationEl instanceof NodeList
				? paginationEl[0]
				: paginationEl;
		if (!el) return;
		const fill = el.querySelector(".swiper-pagination-progressbar-fill");
		if (!fill) return;
		const total = Array.from(swiper.slides).filter(
			(slide) => !slide.classList.contains("swiper-slide-duplicate")
		).length;
		if (total < 1) return;
		const progress = (swiper.realIndex + 1) / total;
		fill.style.transform = `translate3d(0,0,0) scaleX(${progress})`;
	}
	window.triggerFadeUp = function (slide) {

		const texts = slide.querySelectorAll(".text-fd-up");

		texts.forEach((el) => {
			el.classList.remove("is-visible");

			// force reflow
			void el.offsetWidth;

			el.classList.add("is-visible");
		});
	};


	// 1. Initialize Swiper
	var primarySwiper = new Swiper(".primary-banner .swiper", {
		slidesPerView: 1,
		observer: true,
		observeParents: true,
		preventInteractionOnTransition: false,
		speed: 1205,
		autoplay: false,
		lazy: {
			loadPrevNext: true,
		},
		effect: "fade",
		fadeEffect: {
			crossFade: true,
		},
		loop: true,
		init: false,
		navigation: {
			nextEl: ".primary-banner .next",
			prevEl: ".primary-banner .prev",
		},
		pagination: {
			el: ".primary-banner .swiper-pagination",
			type: "bullets",
			clickable: true,
			renderBullet: function (index, className) {
				return `<span class="${className}" data-index="${index}"></span>`;
			},
		},
	});

	// 2. Global Variables
	let progressInterval = null;
	let timer = null;
	let isPaused = false; // NEW: Track manual pause state
	const slideTimeout = 500000;

	// 3. Progress Track Function
	function startProgressTrack() {
		if (progressInterval) clearInterval(progressInterval);
		if (isPaused) return; // Don't start animation if paused

		const progressTrack = document.querySelector(".primary-banner .progress-track");
		if (!progressTrack) return;

		const intervalStep = 20;
		// Get current width to allow resuming from same spot if desired, 
		// otherwise it defaults to 0 on new slides.
		let progress = parseFloat(progressTrack.style.width) || 0;

		progressInterval = setInterval(() => {
			if (!isPaused) {
				progress += (intervalStep / slideTimeout) * 100;
				if (progress >= 100) {
					clearInterval(progressInterval);
					progressTrack.style.width = "100%";
				} else {
					progressTrack.style.width = `${progress}%`;
				}
			}
		}, intervalStep);
	}

	function resetProgressTrack() {
		if (progressInterval) {
			clearInterval(progressInterval);
			progressInterval = null;
		}
		const progressTrack = document.querySelector(".primary-banner .progress-track");
		if (progressTrack) {
			progressTrack.style.width = "0%";
		}
	}

	// 4. Video & Timer Handling
	function handleVideoPlayback(slide) {
		if (timer) {
			clearTimeout(timer);
			timer = null;
		}

		if (!isPaused) {
			resetProgressTrack();
		}

		// Stop all videos first
		const allVideos = document.querySelectorAll(".primary-banner-video");
		allVideos.forEach((video) => {
			video.pause();
		});

		// Detect which video to play based on screen width
		// Adjust 768 to match your specific CSS breakpoint (e.g., 1024 for desktop)
		const isMobile = window.innerWidth <= 768;
		const videoSelector = isMobile ? "video.mobile" : "video.desktop";

		let videoElement = slide.querySelector(videoSelector);

		// Fallback: If the specific mobile/desktop video doesn't exist, 
		// grab whatever video is available in the slide.
		if (!videoElement) {
			videoElement = slide.querySelector("video");
		}

		if (videoElement) {
			if (!isPaused) {
				startProgressTrack();
				videoElement.play().catch((error) => {
					// Handle browsers that block autoplay
					timer = setTimeout(() => {
						primarySwiper.slideNext();
					}, slideTimeout);
				});
			}

			videoElement.onended = function () {
				if (!isPaused) {
					if (primarySwiper.slides.length === 1) {
						videoElement.currentTime = 0;
						videoElement.play();
					} else {
						primarySwiper.slideNext();
					}
				}
			};

		} else {
			// Handle Image Slides
			if (!isPaused) {
				startProgressTrack();
				timer = setTimeout(() => {
					primarySwiper.slideNext();
				}, slideTimeout);
			}
		}
	}

	// 5. Swiper Event Listeners
	primarySwiper.on("slideChangeTransitionEnd", function () {
		const currentSlide = primarySwiper.slides[primarySwiper.activeIndex];
		handleVideoPlayback(currentSlide);
		triggerFadeUp(currentSlide);
	});

	primarySwiper.on("slideChangeTransitionStart", function () {
		if (!isPaused) {
			resetProgressTrack();
		}
	});

	primarySwiper.on("init", function () {
		const currentSlide = primarySwiper.slides[primarySwiper.activeIndex];
		handleVideoPlayback(currentSlide);
		triggerFadeUp(currentSlide);
	});

	// 6. Pause Button Logic (.pause-track)
	const pauseTrackBtn = document.querySelector(".pause-track");
	if (pauseTrackBtn) {
		pauseTrackBtn.addEventListener("click", function () {
			isPaused = !isPaused; // Toggle state

			const currentSlide = primarySwiper.slides[primarySwiper.activeIndex];
			const video = currentSlide.querySelector("video");

			if (isPaused) {
				// STOP
				this.classList.add("paused");
				if (progressInterval) clearInterval(progressInterval);
				if (timer) clearTimeout(timer);
				if (video) video.pause();
			} else {
				// RESUME
				this.classList.remove("paused");
				if (video) {
					video.play();
					startProgressTrack();
				} else {
					startProgressTrack();
					// Resume the remaining time (simplified as full timeout here)
					timer = setTimeout(() => {
						primarySwiper.slideNext();
					}, slideTimeout);
				}
			}
		});
	}

	// 7. Manual Video Click Handling
	const primaryBannerVideo = document.querySelectorAll(".primary-banner-video");
	primaryBannerVideo.forEach(function (videoElement) {
		videoElement.addEventListener("click", function (event) {
			if (this.paused) {
				this.play();
				this.parentNode.classList.remove("pause");
			} else {
				this.pause();
				this.parentNode.classList.add("pause");
			}
		});
	});

	// 8. Run Init
	primarySwiper.init();





	window.initSwiper = [];

	$(".init-swiper .swiper").each(function (index) {
		const $this = $(this);

		// Flags
		const isGioithieuResources = $this.closest(".gioithieu-resources").length > 0;
		const isLoop = $this.hasClass("is-loop") || $this.closest(".init-swiper").hasClass("is-loop") || isGioithieuResources;
		const isTriggerLoadedNext = $this.hasClass("trigger-loaded-next") || $this.closest(".init-swiper").hasClass("trigger-loaded-next");
		const isCenter = $this.hasClass("is-center-slide") || $this.closest(".init-swiper").hasClass("is-center-slide");

		// Data attrs
		let time = Number($this.data("time"));
		let dataspeed = Number($this.data("speed"));
		let initialSlide = Number($this.data("initial"));

		// Defaults
		if (!Number.isFinite(time)) time = 5000;
		if (!Number.isFinite(dataspeed)) dataspeed = 1205;

		if (window.innerWidth <= 768 && time === 0) {
			dataspeed = 5000;
		}


		// Pagination type
		let paginationType = "bullets";

		if ($this.hasClass("fraction")) {
			paginationType = "fraction";
		} else if ($this.hasClass("progress")) {
			paginationType = "progressbar";
		}

		// Unique classes
		$this.addClass("swiper-init-" + index);

		$this
			.parents(".init-swiper")
			.find(".prev")
			.addClass("prev-nav-" + index);

		$this
			.parents(".init-swiper")
			.find(".next")
			.addClass("next-nav-" + index);

		$this
			.parents(".init-swiper")
			.find(".swiper-pagination")
			.addClass("pagination-inst-" + index);

		// Base options
		const options = {
			observer: true,
			observeParents: true,

			rewind: !isLoop,
			loop: isLoop,

			speed: dataspeed,

			watchSlidesProgress: true,
			slidesPerView: "auto",

			centeredSlides: isCenter,

			lazy: {
				loadPrevNext: true,
			},

			autoplay: {
				delay: time,
				pauseOnMouseEnter: true,
				disableOnInteraction: false,
			},

			navigation: {
				nextEl: ".next-nav-" + index,
				prevEl: ".prev-nav-" + index,
			},

			pagination: {
				el: ".pagination-inst-" + index,
				type: paginationType,
				clickable: true,
				dynamicMainBullets: 1,
			},

			on: {
				beforeInit: function () {
					window.initSwiper.push(this);
				},

				init: function () {
					// Fix duplicate fancybox in loop mode
					if (isLoop) {
						window.lozadObserver?.observe();

						$(this.el)
							.find(".swiper-slide-duplicate a[data-fancybox]")
							.removeAttr("data-fancybox");
					}

					if (isGioithieuResources) {
						updateGioithieuResourcesProgress(this);
					}

					triggerLozadNextSlideImage(this);
				},

				paginationUpdate: function (swiper) {
					if (isGioithieuResources) {
						updateGioithieuResourcesProgress(swiper);
					}
				},

				navigationNext: function (swiper) {
					swiper.params.speed = 1200;
				},

				navigationPrev: function (swiper) {
					swiper.params.speed = 1200;
				},

				transitionEnd: function (swiper) {
					swiper.params.speed = dataspeed;
				},

				slideChange: function () {
					// Pause videos when slide changes
					if ($this.hasClass("slide-has-video")) {
						const $videos = $this.find("video");

						if ($videos.length) {
							$videos[0].pause();
						}

						$this.find(".swiper-slide").removeClass("play-video");
						$this.find(".play-btn").removeClass("active");
					}

					triggerLozadNextSlideImage(this);
				},

				resize: function (swiper) {
					const totalSlidesWidth = swiper.slidesSizesGrid.reduce(
						(acc, curr) => acc + curr,
						0
					);

					swiper.el.classList.toggle(
						"center-slide-active",
						totalSlidesWidth < swiper.size
					);

					// Skip for continuous marquee mode (time === 0): forcing
					// slidesPerGroup to match visible slides count conflicts with
					// Swiper 11's loop requirements (slides >= slidesPerView + slidesPerGroup)
					// and causes the loop/freeMode autoplay to stall once it runs
					// out of real slides.
					if (time !== 0 && !isGioithieuResources) {
						autoSetSlidesPerGroup(swiper);
					}
				},
			},
		};

		// Better center mode behavior
		if (isCenter) {
			options.centeredSlidesBounds = true;
		}

		// Keep every slide reachable without centering (centering leaves a left gap).
		// Fractional --spv makes 2 slides "visible", so auto slidesPerGroup would skip 2/4.
		if (isGioithieuResources) {
			options.centeredSlides = false;
			options.centeredSlidesBounds = false;
			options.slidesPerGroup = 1;
			options.slideToClickedSlide = true;
			options.loop = true;
			options.rewind = false;
		}

		// Initial slide
		if (Number.isFinite(initialSlide)) {
			options.initialSlide = initialSlide;
		}

		// Continuous autoplay mode
		if (time === 0) {
			options.loop = true;
			options.rewind = false; // Prevent conflict with loop

			options.autoplay = {
				delay: 0,
				disableOnInteraction: false,
				pauseOnMouseEnter: false,
				reverseDirection: false,
			};

			// Use data-speed if provided
			options.speed = dataspeed || 1800;

			// Remove nav for marquee mode
			delete options.navigation;

			// Smooth continuous movement
			options.freeMode = true; // For Swiper 11, linear transition is used
			options.allowTouchMove = false; // typically marquee is non-interactive but we can leave it

			// Keep slidesPerGroup fixed so the loop slide-count requirement
			// (slides >= slidesPerView + slidesPerGroup) stays satisfied on all viewports
			options.slidesPerGroup = 1;
			options.loopAdditionalSlides = 5;
		}

		// Init
		const swiperInstance = new Swiper(".swiper-init-" + index, options);

		if (time === 0 && $this.closest(".home-customer").length) {
			setupHomeCustomerMarquee(
				swiperInstance,
				$this.closest(".init-swiper"),
				dataspeed || 1800
			);
		}
	});

	function setupHomeCustomerMarquee(swiper, $container, baseSpeed) {
		const $prev = $container.find(".prev");
		const $next = $container.find(".next");
		if (!$prev.length && !$next.length) return;

		let reverse = false;
		let timer = null;

		if (swiper.autoplay && swiper.autoplay.running) {
			swiper.autoplay.stop();
		}

		function setButtons() {
			$prev.toggleClass("active", !reverse);
			$next.toggleClass("active", reverse);
		}

		setButtons();

		function stepPx() {
			const snaps = swiper.snapGrid || [];
			if (snaps.length > 1) {
				return Math.abs(snaps[1] - snaps[0]) || 300;
			}
			return (swiper.slidesSizesGrid && swiper.slidesSizesGrid[0]) || 300;
		}

		function durationFor(distance) {
			return Math.max(280, Math.round((distance / stepPx()) * baseSpeed));
		}

		function clearTimer() {
			if (timer) {
				window.clearTimeout(timer);
				timer = null;
			}
		}

		function remaining(fromTranslate) {
			const size = stepPx();
			const pos = (((-fromTranslate) % size) + size) % size;
			if (reverse) {
				return pos < 2 ? size : pos;
			}
			const rest = size - pos;
			return rest < 2 ? size : rest;
		}

		function wrapTranslate() {
			const a = swiper.minTranslate();
			const b = swiper.maxTranslate();
			const minT = Math.min(a, b);
			const maxT = Math.max(a, b);
			const span = maxT - minT;
			if (!(span > 1)) return;
			const t = swiper.getTranslate();
			if (t > maxT + 1) {
				swiper.setTransition(0);
				swiper.setTranslate(t - span);
			} else if (t < minT - 1) {
				swiper.setTransition(0);
				swiper.setTranslate(t + span);
			}
		}

		function tick(distance) {
			if (swiper.destroyed) return;
			wrapTranslate();
			const from = swiper.getTranslate();
			const duration = durationFor(distance);
			const to = reverse ? from + distance : from - distance;
			swiper.setTransition(duration);
			swiper.setTranslate(to);
			clearTimer();
			timer = window.setTimeout(() => {
				swiper.setTransition(0);
				wrapTranslate();
				swiper.updateActiveIndex();
				swiper.updateSlidesClasses();
				tick(stepPx());
			}, duration);
		}

		function startFromCurrent() {
			clearTimer();
			const current = swiper.getTranslate();
			swiper.setTransition(0);
			swiper.setTranslate(current);
			swiper.animating = false;
			tick(remaining(current));
		}

		startFromCurrent();

		function changeDirection(wantReverse) {
			if (swiper.destroyed || reverse === wantReverse) return;
			reverse = wantReverse;
			setButtons();
			startFromCurrent();
		}

		$prev.on("click", function (e) {
			e.preventDefault();
			changeDirection(false);
		});

		$next.on("click", function (e) {
			e.preventDefault();
			changeDirection(true);
		});
	}


	var homeProductTop = new Swiper('.large-center-swiper .swiper', {
		slidesPerView: 1,
		spaceBetween: 0,
		rewind: true,
		centeredSlides: true,
		autoplay: {
			delay: 5000,
			disableOnInteraction: false,
		},
		loop: true,
		initialSlide: 2,
		navigation: {
			nextEl: ".large-center-swiper .next",
			prevEl: ".large-center-swiper .prev",
		},
		pagination: {
			el: ".large-center-swiper .swiper-pagination",
			type: "bullets",
			clickable: true,

		},
		speed: 800,
		breakpoints: {
			320: {

				slidesPerView: 1,
				spaceBetween: 0,
				allowTouchMove: true,
			},

			1201: {
				centeredSlides: true,
				allowTouchMove: true,
				slidesPerView: 1.72,
				spaceBetween: 0,
			},
		},

	});



	var gridSwiper = new Swiper(".grid-2-swiper .swiper", {
		preventInteractionOnTransition: true,
		observer: true,
		observeParents: true,
		rewind: true,
		speed: 1205,
		autoplay: {
			delay: 4000,
			pauseOnMouseEnter: true,
		},
		lazy: {
			loadPrevNext: true,
		},
		spaceBetween: 15,
		observeParents: true,
		simulateTouch: false,
		breakpoints: {

			300: {
				slidesPerView: 1,
				spaceBetween: 12,
				grid: {
					rows: 1,
					fill: "row",
				},
			},

			576: {
				slidesPerView: 2,
				grid: {
					rows: 2,
					fill: "row",
				},
			},
			1024: {
				slidesPerView: 2,
				spaceBetween: 20,
				grid: {
					rows: 2,
					fill: "row",
				},
			},
			1400: {
				slidesPerView: 2,
				spaceBetween: 40,
				grid: {
					rows: 2,
					fill: "row",
				},
			},
		},
		navigation: {
			nextEl: ".grid-2-swiper .next",
			prevEl: ".grid-2-swiper .prev",
		},
		pagination: {
			el: ".grid-2-swiper  .swiper-pagination",
			type: "bullets",
			clickable: true,

		},
	});

	var gridSwiper = new Swiper(".gioithieu-partners .swiper", {
		preventInteractionOnTransition: true,
		observer: true,
		observeParents: true,
		rewind: true,
		speed: 1205,
		autoplay: {
			delay: 4000,
			pauseOnMouseEnter: true,
		},
		lazy: {
			loadPrevNext: true,
		},
		spaceBetween: 15,
		observeParents: true,
		simulateTouch: false,
		breakpoints: {

			320: {
				slidesPerView: 3,
				spaceBetween: 20,
				grid: {
					rows: 4,
					fill: "row",
				},
			},
			576: {
				slidesPerView: 4,
				spaceBetween: 20,
				grid: {
					rows: 4,
					fill: "row",
				},
			},
			768: {
				slidesPerView: 5,
				spaceBetween: 20,
				grid: {
					rows: 4,
					fill: "row",
				},
			},

			1024: {
				slidesPerView: 4,
				spaceBetween: 20,
				grid: {
					rows: 4,
					fill: "row",
				},
			},
			1200: {
				slidesPerView: 5,
				spaceBetween: 20,
				grid: {
					rows: 4,
					fill: "row",
				},
			},
			1400: {
				slidesPerView: 5,
				spaceBetween: 20,
				grid: {
					rows: 4,
					fill: "row",
				},
			},
		},
		navigation: {
			nextEl: ".gioithieu-partners .next",
			prevEl: ".gioithieu-partners .prev",
		},
		pagination: {
			el: ".gioithieu-partners  .swiper-pagination",
			type: "bullets",
			clickable: true,

		},
	});



	function syncNiengRangMethodsTabOffset(swiper) {
		if (!swiper || swiper.destroyed || !swiper.slides.length) return;

		const last = swiper.slides[swiper.slides.length - 1];
		const space = Number(swiper.params.spaceBetween) || 0;
		const slidesWidth = Array.from(swiper.slides).reduce((sum, slide, index) => {
			return (
				sum +
				slide.offsetWidth +
				(index < swiper.slides.length - 1 ? space : 0)
			);
		}, 0);
		const overflowing = slidesWidth > swiper.size + 1;
		const nextOffset = overflowing
			? Math.max(0, Math.round(swiper.size - last.offsetWidth))
			: 0;

		if (swiper.params.slidesOffsetAfter === nextOffset) return;

		swiper.params.slidesOffsetAfter = nextOffset;
		swiper.update();
	}

	function showNiengRangMethodsTabSlide(swiper, index, speed) {
		if (!swiper || swiper.destroyed || index == null || index < 0) return;
		swiper.slideTo(index, speed);
	}

	document.querySelectorAll(".niengrang-methods .tab-nav").forEach((nav) => {
		const swiperEl = nav.querySelector(".swiper");
		if (!swiperEl) return;

		const slides = nav.querySelectorAll(".swiper-slide");
		let initialSlide = 0;
		slides.forEach((slide, index) => {
			if (slide.classList.contains("active")) {
				initialSlide = index;
			}
		});

		const methodsTabSwiper = new Swiper(swiperEl, {
			slidesPerView: "auto",
			spaceBetween: 24,
			slidesPerGroup: 1,
			observer: true,
			observeParents: true,
			watchOverflow: true,
			watchSlidesProgress: true,
			rewind: true,
			speed: 600,
			autoplay: false,
			slideToClickedSlide: false,
			centerInsufficientSlides: true,
			initialSlide,
			navigation: {
				nextEl: nav.querySelector(".next"),
				prevEl: nav.querySelector(".prev"),
			},
			on: {
				init(swiper) {
					requestAnimationFrame(() => {
						syncNiengRangMethodsTabOffset(swiper);
						showNiengRangMethodsTabSlide(swiper, initialSlide, 0);
					});
				},
				resize(swiper) {
					syncNiengRangMethodsTabOffset(swiper);
				},
			},
		});

		nav.addEventListener("click", (event) => {
			const slide = event.target.closest(".swiper-slide");
			if (!slide || !swiperEl.contains(slide)) return;

			const index = Array.prototype.indexOf.call(
				methodsTabSwiper.slides,
				slide
			);
			showNiengRangMethodsTabSlide(methodsTabSwiper, index);
		});
	});

	var niengRangProcess = new Swiper(".niengrang-process .swiper", {
		preventInteractionOnTransition: true,
		observer: true,
		observeParents: true,
		rewind: true,
		speed: 1205,
		autoplay: {
			delay: 4000,
			pauseOnMouseEnter: true,
		},
		lazy: {
			loadPrevNext: true,
		},
		spaceBetween: 15,
		observeParents: true,
		breakpoints: {

			320: {
				slidesPerView: 2,
				spaceBetween: 20,

			},

			768: {
				slidesPerView: 2,
				spaceBetween: 60,

			},

			1024: {
				slidesPerView: 4,
				spaceBetween: 60,

			},
			1600: {
				slidesPerView: 4,
				spaceBetween: 135,
			},

		},
		navigation: {
			nextEl: ".niengrang-process .next",
			prevEl: ".niengrang-process .prev",
		},
		pagination: {
			el: ".niengrang-process  .swiper-pagination",
			type: "bullets",
			clickable: true,

		},
	});



	try {
		var homeDevelopeSwiper = new Swiper(".home-gallery .swiper", {
			spaceBetween: 10,
			watchSlidesProgress: true,
			slideToClickedSlide: true,
			speed: 800,
			mousewheel: false,
			autoplay: true,
			slidesPerView: "auto",
			lazy: {
				loadPrevNext: true,
			},
			breakpoints: {
				200: {
					spaceBetween: 10,
				},
				476: {
					spaceBetween: 20,
				},
				768: {
					spaceBetween: 30,
				},
				1024: {
					spaceBetween: 40,
				},
				1280: {
					spaceBetween: 32,
				},
			},
			navigation: {
				nextEl: ".home-gallery .next",
				prevEl: ".home-gallery .prev",
			},
			pagination: {
				el: ".home-gallery .swiper-pagination",
				type: "bullets",
				clickable: true,

			},
		});

	} catch (error) {

	}



	try {
		// Scope everything to .home-gallery
		const gallery = document.querySelector('.home-gallery');
		if (!gallery) return;

		const slides = gsap.utils.toArray('.slide', gallery);
		const paginationContainer = gallery.querySelector('.pagination');
		const prevBtn = gallery.querySelector('.prev');
		const nextBtn = gallery.querySelector('.next');

		let activeIndex = 2; // Start with the 3rd item as active center
		let config, innerX, outerX, positions;

		function calculateLayout() {
			const ww = window.innerWidth;
			if (ww < 400) {
				config = {
					center: { w: ww - 20, h: 280 },
					inner: { w: 30, h: 220 },
					outer: { w: 0, h: 200 },
					gap: 16
				};
			} else if (ww < 640) {
				config = {
					center: { w: ww - 80, h: 360 },
					inner: { w: 120, h: 260 },
					outer: { w: 80, h: 200 },
					gap: 16
				};
			} else if (ww < 1024) {
				config = {
					center: { w: ww * 0.8, h: 380 },
					inner: { w: 100, h: 320 },
					outer: { w: 0, h: 260 },
					gap: 20
				};
			} else if (ww < 1400) {
				config = {
					center: { w: 700, h: 500 },
					inner: { w: 160, h: 400 },
					outer: { w: 120, h: 320 },
					gap: 24
				};
			} else {
				config = {
					center: { w: 992, h: 600 },
					inner: { w: 200, h: 476 },
					outer: { w: 200, h: 400 },
					gap: 32
				};
			}

			innerX = (config.center.w / 2) + config.gap + (config.inner.w / 2);
			outerX = innerX + (config.inner.w / 2) + config.gap + (config.outer.w / 2);

			positions = [
				{ x: -outerX, w: config.outer.w, h: config.outer.h, zIndex: 1, opacity: 0.3 }, // Outer Left (-2)
				{ x: -innerX, w: config.inner.w, h: config.inner.h, zIndex: 2, opacity: 0.8 }, // Inner Left (-1)
				{ x: 0, w: config.center.w, h: config.center.h, zIndex: 3, opacity: 1 },   // Center (0)
				{ x: innerX, w: config.inner.w, h: config.inner.h, zIndex: 2, opacity: 0.8 }, // Inner Right (1)
				{ x: outerX, w: config.outer.w, h: config.outer.h, zIndex: 1, opacity: 0.3 }  // Outer Right (2)
			];

			const container = gallery.querySelector('.slider-container');
			if (container) {
				container.style.height = (config.center.h + 40) + 'px';
			}
		}

		calculateLayout();

		// Force GSAP core structural initialization
		// Set x and y to 0 to override any computed pixel translations from CSS transform: translate(-50%, -50%)
		gsap.set(slides, { xPercent: -50, yPercent: -50, x: 0, y: 0 });

		// Generate Pagination Dots dynamically
		slides.forEach((_, i) => {
			const dot = document.createElement('div');
			dot.classList.add('dot');
			if (i === activeIndex) dot.classList.add('active');

			dot.addEventListener('click', () => {
				activeIndex = i;
				updateSlider();
			});
			paginationContainer.appendChild(dot);
		});

		const dots = gsap.utils.toArray('.dot', gallery);

		function updateSlider() {
			slides.forEach((slide, i) => {
				slide.classList.remove('active');
				if (i === activeIndex) slide.classList.add('active');

				// Calculate cyclic relative distance from activeIndex (-floor(N/2) to floor(N/2))
				let diff = i - activeIndex;
				while (diff < -Math.floor(slides.length / 2)) diff += slides.length;
				while (diff > Math.floor(slides.length / 2)) diff -= slides.length;

				let state;
				// Map valid relative offsets (-2 to 2) to our visible positions array
				if (diff >= -2 && diff <= 2) {
					state = positions[diff + 2];
				} else {
					// Hidden state configuration for the other 6 slides rotating in the background
					state = {
						x: diff > 0 ? outerX + 150 : -outerX - 150,
						w: config.outer.w,
						h: config.outer.h,
						zIndex: 0,
						opacity: 0
					};
				}

				// Animate properties seamlessly
				gsap.to(slide, {
					x: state.x,
					width: state.w,
					height: state.h,
					zIndex: state.zIndex,
					opacity: state.opacity,
					duration: 0.8,
					ease: "power3.inOut",
					overwrite: "auto"
				});
			});

			// Sync Pagination UI State
			dots.forEach((dot, i) => {
				dot.classList.toggle('active', i === activeIndex);
			});
		}

		// Initialize layout positions
		updateSlider();

		let resizeTimer;
		window.addEventListener('resize', () => {
			clearTimeout(resizeTimer);
			resizeTimer = setTimeout(() => {
				calculateLayout();
				updateSlider();
			}, 150);
		});

		// Event Handlers
		nextBtn.addEventListener('click', () => {
			activeIndex = (activeIndex + 1) % slides.length;
			updateSlider();
		});

		prevBtn.addEventListener('click', () => {
			activeIndex = (activeIndex - 1 + slides.length) % slides.length;
			updateSlider();
		});

	} catch (error) {
	}









}